import styled from "styled-components";

export const Container = styled.div`
	display: flex ;
	align-items:center;
	justify-content: center ;
	
	img{
		width: 0.8125rem;
		height: 0.8125rem;
	}
	select{
	 cursor: pointer;
	background:none ;
	border:none ;
	outline:none ;
	color:#ffffff ;
	font-weight:500 ;
	font-size:1rem ;
}
 option{
	background-color: #050B1E ;
	position	:absolute ;
	border: 1px solid #050B1E ;
	font-size:1rem ;
}
`

